/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InstanceBulkActionResult } from './InstanceBulkActionResult';
import {
    InstanceBulkActionResultFromJSON,
    InstanceBulkActionResultFromJSONTyped,
    InstanceBulkActionResultToJSON,
    InstanceBulkActionResultToJSONTyped,
} from './InstanceBulkActionResult';

/**
 * 
 * @export
 * @interface ExecuteInstanceBulkDecision200Response
 */
export interface ExecuteInstanceBulkDecision200Response {
    /**
     * 
     */
    data?: InstanceBulkActionResult;
}

/**
 * Check if a given object implements the ExecuteInstanceBulkDecision200Response interface.
 */
export function instanceOfExecuteInstanceBulkDecision200Response(value: object): value is ExecuteInstanceBulkDecision200Response {
    return true;
}

export function ExecuteInstanceBulkDecision200ResponseFromJSON(json: any): ExecuteInstanceBulkDecision200Response {
    return ExecuteInstanceBulkDecision200ResponseFromJSONTyped(json, false);
}

export function ExecuteInstanceBulkDecision200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecuteInstanceBulkDecision200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : InstanceBulkActionResultFromJSON(json['data']),
    };
}

export function ExecuteInstanceBulkDecision200ResponseToJSON(json: any): ExecuteInstanceBulkDecision200Response {
    return ExecuteInstanceBulkDecision200ResponseToJSONTyped(json, false);
}

export function ExecuteInstanceBulkDecision200ResponseToJSONTyped(value?: ExecuteInstanceBulkDecision200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': InstanceBulkActionResultToJSON(value['data']),
    };
}

